module.exports = __webpack_public_path__ + "static/img/ZZtu4@2x.76983770.png";